import React from 'react';
import {useNavigate} from 'react-router-dom';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Chip,
} from '@mui/material';
import {ISharedMessageItem} from '../../../dto/MessageSharing.dto';
import {SharedMessageBadge} from './SharedMessageBadge';

interface SharedListSectionProps {
  sharedItems: ISharedMessageItem[];
  messageType: string;
}

export const SharedListSection: React.FC<SharedListSectionProps> = ({
  sharedItems,
  messageType,
}) => {
  const navigate = useNavigate();

  if (!sharedItems || sharedItems.length === 0) {
    return null;
  }

  const handleItemClick = (item: ISharedMessageItem) => {
    navigate(`/messages/${messageType}/${item.id}/view`);
  };

  return (
    <Box
      sx={{
        mb: 2,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '10px',
        backgroundColor: 'background.paper',
        overflow: 'hidden',
      }}>
      <Box
        sx={{
          px: 2,
          py: 1.5,
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}>
        <Typography variant='subtitle2' color='text.primary' fontWeight={600}>
          Shared from District
        </Typography>
      </Box>
      <List disablePadding>
        {sharedItems.map(item => (
          <ListItem key={item.id} disablePadding divider>
            <ListItemButton onClick={() => handleItemClick(item)}>
              <ListItemText
                primary={item.owner_company_name}
                primaryTypographyProps={{
                  variant: 'body2',
                  color: 'text.primary',
                }}
              />
              <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                <SharedMessageBadge
                  ownerCompanyName={item.owner_company_name}
                />
                <Chip
                  label='Read Only'
                  size='small'
                  variant='outlined'
                  color='warning'
                />
              </Box>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};
